import { Component } from "@angular/core";
import {ChartParams} from "../../views/chart/chart.component";
import {TranslateService} from "../../translate";
import {EventsService} from "../../lib/EventsService";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {HelperService} from "../../lib/helper.service";
import {ModalService} from "../../views/modal/base_modal.component";
import {BaseComponent} from "../../views/base.component";
import { BillingService2 } from "../billing.service";
import { ICharts } from "../../models/responce_result.model";

@Component({
	selector: 'disable-recurrent',
	templateUrl: './disable-recurrent.component.html',
})
export class DisableRecurrentComponent extends BaseComponent {
	disableRecurrentChart = new ChartParams();
	
	disableRecurrentChart2 = new ChartParams();
	
	disableRecurrentDetailChart = new ChartParams();
	
	addFilterParams = {
		userType: 'user',
		isBilling: true,
		dateFilters: ['dateTime', 'dateCreated', 'datePaid', 'dateSiteCreated', 'datePublished'],
		dateType: 'dateTime'
	};
	
	constructor(
		public translate: TranslateService,
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public filter: FilterFormService,
		public service2: BillingService2,
		public modalService: ModalService,
		public helper: HelperService,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
		
		const me = this;
		
		me.disableRecurrentChart.setOptions({
			title: me.translate.__A('disable_recurrent.manual'),
			names: {
				count: 'Кол-во отписок'
			},
		});
		
		
		me.disableRecurrentChart2.setOptions({
			title: me.translate.__A('disable_recurrent.recurrent'),
			names: {
				count: 'Кол-во отписок'
			},
		});
		
		
		me.disableRecurrentDetailChart.setOptions({
			title: me.translate.__A('disable_recurrent.detail'),
			axis: {
				y: {
					min   : 1,
					ticks : 5,
					label: {
						text     : 'Сайты',
						position : 'outer-middle'
					}
				}
			},
			names: {
				disableBeforePaid: me.translate.__A('disable_recurrent.disableBeforePaid'),
				disableAfterPaid: me.translate.__A('disable_recurrent.disableAfterPaid'),
				disableOther: me.translate.__A('disable_recurrent.disableOther'),
				// disableWithoutRecurentPaid: me.translate.__A('disable_recurrent.disableWithoutRecurentPaid'),
			},
		});
	}
	
	async getData() {
		const me = this;
		
		await me.getChart();
	}
	
	
	async getChart() {
		const me = this;
		
		const fp = me.filter.filterParams;
		
		me.disableRecurrentChart.showLoader();
		const { charts } = await me.service2.disableRecurrent.chart(fp).toPromise();
		me.disableRecurrentChart.data = charts;
		me.disableRecurrentChart.hideLoader();
		
		me.disableRecurrentChart2.showLoader();
		const { charts: charts2 } = await me.service2.disableRecurrent.get<ICharts>(
			fp,
			'charts2',
		).toPromise();
		me.disableRecurrentChart2.data = charts2;
		me.disableRecurrentChart2.hideLoader();
		
		me.disableRecurrentDetailChart.showLoader();
		const { charts: charts4 } = await me.service2.disableRecurrent.get<ICharts>(
			me.filter.filterParams,
			'detail_chart'
		).toPromise();
		me.disableRecurrentDetailChart.data = charts4;
		me.disableRecurrentDetailChart.hideLoader();
	}
}
